import { useState } from "react";

export const useSearchInput = (onSearch) => {
  const [textToSearch, setTextToSearch] = useState("");

  const handleChangeSearchText = (e) => {
    if (e.target.value === "") {
      onSearch("");
    }
    setTextToSearch(e.target.value);
  };
  const onClickToSearch = () => {
    onSearch(textToSearch);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch(textToSearch);
    }
  };

  return {
    textToSearch,
    handleChangeSearchText,
    onClickToSearch,
    handleKeyDown,
  };
};
